var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"logs-strategy-detail-container"},[_c('base-form',_vm._b({on:{"handleConfirm":_vm.handleConfirm}},'base-form',_vm.form,false))],1)}
var staticRenderFns = []

export { render, staticRenderFns }